module.exports = __webpack_public_path__ + "img/27.07010aeb.jpg";